import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css"; // Ensure this CSS file is included
import logo from "../assets/logo.png"; // Your logo path

const VerificationPage = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState(["", "", "", ""]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return; // Allow only numbers

    let newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Auto-focus to the next input field
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.join("").length === 4) {
      alert("Verification Successful!");
      navigate("/reset-password"); // Redirect to reset password page
    } else {
      alert("Please enter a valid 4-digit code.");
    }
  };

  return (
    <div className="verification-page">
      <div className="verification-container">
        <img src={logo} alt="Timely Logo" className="logo-image" />
        <h2 className="verification-title">Two-factor Verification</h2>
        <p className="verification-text">Enter your code which has been sent to your email below.</p>

        <form className="verification-form" onSubmit={handleSubmit}>
          <div className="otp-inputs">
            {code.map((num, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                className="otp-box"
                value={num}
                onChange={(e) => handleChange(e, index)}
              />
            ))}
          </div>

          <p className="verification-info">A code has been sent to your phone</p>
          <button type="submit" className="verify-btn">Verify</button>

          <p className="resend-text">
            Resend in <span id="countdown">00:57</span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default VerificationPage;
